import {
  AuthUserGroup,
  AuthUserGroupFromJSON,
  AuthUserOperationMenu,
  AuthUserOperationMenuFromJSON,
  AuthUserTopMenu,
  AuthUserTopMenuFromJSON,
  defaultAuthUserGroup,
  defaultAuthUserOperationMenu,
  defaultAuthUserTopMenu,
  defaultSystemCode,
  exists,
  SystemBatchMenuDetail,
  SystemBatchMenuDetailFromJSON,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface AuthUser {
  id: number
  userId: string
  name: string
  systemGroupId: number
  branchCode: SystemCode
  placeCode: SystemCode
  group: AuthUserGroup
  operationMenu: AuthUserOperationMenu
  topMenu: AuthUserTopMenu
  batchMenu: SystemBatchMenuDetail[]
  note: string
  revision: number
  apiVersion: string
}

export function AuthUserFromJSON(json: any): AuthUser {
  return {
    id: exists(json, 'id') ? json.id : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    systemGroupId: exists(json, 'system_group_id') ? json.system_group_id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    placeCode: exists(json, 'place_code')
      ? SystemCodeFromJSON(json.place_code)
      : defaultSystemCode(),
    note: exists(json, 'note') ? json.note : '',
    group: exists(json, 'group')
      ? AuthUserGroupFromJSON(json.group)
      : defaultAuthUserGroup(),
    operationMenu: exists(json, 'operation_menu')
      ? AuthUserOperationMenuFromJSON(json.operation_menu)
      : defaultAuthUserOperationMenu(),
    topMenu: exists(json, 'top_menu')
      ? AuthUserTopMenuFromJSON(json.top_menu)
      : defaultAuthUserTopMenu(),
    batchMenu: exists(json, 'batch_menu')
      ? json.batch_menu.map(SystemBatchMenuDetailFromJSON)
      : [],
    revision: exists(json, 'revision') ? json.revision : 1,
    apiVersion: exists(json, 'api_version') ? json.api_version : ''
  }
}

export const defaultAuthUser = (): AuthUser => ({
  id: 0,
  userId: '',
  name: '',
  systemGroupId: 0,
  branchCode: defaultSystemCode(),
  placeCode: defaultSystemCode(),
  group: defaultAuthUserGroup(),
  operationMenu: defaultAuthUserOperationMenu(),
  topMenu: defaultAuthUserTopMenu(),
  batchMenu: [],
  note: '',
  revision: 1,
  apiVersion: ''
})
